import {
  Hussle_Video,
  Hussle_Main_Logo,
  Hussle_Logo,
} from "../../assets/icons";
import useAppNavigation from "../../hooks/useAppNavigation";
import useAppAccessor from "../../hooks/useappAccessor";
import { getBrandColor } from "../../utils/brand.util";

const LiveEndAttendee = () => {
  const { navigate } = useAppNavigation();
  const { getLiveMainData, getUserData } = useAppAccessor();
  const { joinData } = getLiveMainData();
  const { client } = getUserData();

  const isMobile =
    window.innerWidth < 768 ||
    /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);


  return (
    <div
      className={`flex h-screen w-full ${
        isMobile
          ? "bg-black"
          : "bg-gradient-to-b from-[#1C1C1C] to-[#272626] pl-[15%] pr-[15%]"
      } items-center justify-center py-12`}
    >
      <div className="flex-col w-full h-full">
        <div
          className={`flex w-full h-full items-center justify-center rounded ${
            isMobile ? "bg-[#0B0B0B]" : "bg-[#0B0B0B]"
          } p-2`}
        >
          <div className="flex flex-col justify-center items-center">
            <img src={Hussle_Video} height={100} width={100} />
            <img src={Hussle_Main_Logo} width={219} className="mt-12" />
            <span className="text-white text-26px mt-12">
              {"The livestream has ended"}
            </span>
          </div>
        </div>
        <div className="flex w-full items-center justify-center mt-2">
          <span className="text-10px text-[#8D8D8E]">Powered by</span>
          <img src={Hussle_Logo} width={65} className="ml-1 mt-[-2px]" />
        </div>
      </div>
    </div>
  );
};

export default LiveEndAttendee;
